import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const Profile = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const [uploadedImage, setUploadedImage] = useState(null);

  if (isLoading) {
    return <div>Loading ...</div>;
  }

  return (
    isAuthenticated && (
      <>
        <img
          src={uploadedImage || user.picture}
          alt={user.name}
          style={{ width: "120px", borderRadius: "50%" }}
        />

        <h2>Welcome, {user.name}!</h2>
        <p>
          Thank you for using TIL Subscribe! <br/>
          This platform has been designed to streamline the completion of your Subscription Agreement <br/>
          and ensure your information is submitted securely and efficiently. <br/>
        </p>
        <p>
          To get started, please use the <strong>Menu</strong> in the top-right corner to navigate to your Subscription Agreement form.
        </p>
        <p>
          Your responses will be saved securely, and you may return at any time to review or update your information before final submission.
        </p>
        <p>
          We appreciate your trust and look forward to welcoming you as an investor.
        </p>

      </>
    )
  );
};

export default Profile;
